import { fetchCustomers } from '../../customers/api/customers';
import { fetchUser } from '../../users/api/users';

const MUTATIONS_MAP = {
    SET_USER: 'SET_USER',
    SET_WORKSPACES: 'SET_WORKSPACES',
    SET_ACTIVE_WORKSPACE: 'SET_ACTIVE_WORKPSPACE',
    CLEAR_ACTIVE_WORKSPACE: 'CLEAR_ACTIVE_WORKSPACE',
};

const INNER_CUSTOMER_DATA = {
    id: 'inner',
    name: 'Speechki',
    default_limit: null,
};

const state = {
    workspaces: [],
    user: {},
    activeWorkspace: undefined,
};

const getters = {
    hasInnerCustomer(state) {
        return !!(state.user.roles_info && state.user.roles_info[0]);
    },
    workspaceCustomerId(state) {
        if (!state.activeWorkspace || state.activeWorkspace.id === 'inner') return null;

        return state.activeWorkspace.id;
    },
    isInnerWorkspace(state) {
        return !!(state.activeWorkspace && state.activeWorkspace.id === 'inner');
    },
    ready(state, _, __, rootGetters) {
        return !rootGetters.loggedIn || !!(!state.loading && state.activeWorkspace);
    },
};

const mutations = {
    [MUTATIONS_MAP.SET_USER](state, user) {
        state.user = user;
    },
    [MUTATIONS_MAP.SET_WORKSPACES](state, workspaces) {
        state.workspaces = workspaces;
    },
    [MUTATIONS_MAP.SET_ACTIVE_WORKSPACE](state, workspace) {
        state.activeWorkspace = workspace;
        if (workspace && workspace.id) {
            localStorage.setItem('sp-workspace', workspace.id);
        }
    },
    [MUTATIONS_MAP.CLEAR_ACTIVE_WORKSPACE](state) {
        state.activeWorkspace = null;
        localStorage.removeItem('sp-workspace');
    },
};

const actions = {
    async fetchWorkspacesData({ dispatch, rootState }) {
        const [{ results = [] }, user] = await Promise.all([
            fetchCustomers({
                page_size: 150,
            }),
            fetchUser(rootState.auth.user.pk),
        ]);

        await dispatch('setWorkspacesData', { workspaces: results, user });
    },

    setWorkspacesData({ commit, getters }, { workspaces, user }) {
        commit(MUTATIONS_MAP.SET_USER, user);

        const actualWorkspaces = workspaces;

        if (getters.hasInnerCustomer) {
            actualWorkspaces.unshift(INNER_CUSTOMER_DATA);
        }

        commit(MUTATIONS_MAP.SET_WORKSPACES, actualWorkspaces);
    },

    setActiveWorkspace({ commit, state, getters }, workspaceId = 'inner') {
        if (!workspaceId || workspaceId === 'inner') {
            if (getters.hasInnerCustomer) {
                commit(MUTATIONS_MAP.SET_ACTIVE_WORKSPACE, INNER_CUSTOMER_DATA);
                return;
            }

            if (!state.workspaces.length) {
                return;
            }

            commit(MUTATIONS_MAP.SET_ACTIVE_WORKSPACE, state.workspaces[0]);
            return;
        }

        const workspace = state.workspaces.find((w) => w.id === Number(workspaceId));

        commit(MUTATIONS_MAP.SET_ACTIVE_WORKSPACE, workspace);
    },
    clearActiveWorkspace({ commit }) {
        commit(MUTATIONS_MAP.CLEAR_ACTIVE_WORKSPACE);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
